"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LiveEnquiries = void 0;
const throttle_1 = __importDefault(require("lodash/throttle"));
const react_1 = __importStar(require("react"));
const react_query_1 = require("react-query");
const react_redux_1 = require("react-redux");
const styled_components_1 = __importStar(require("styled-components"));
const Colors_1 = require("../../../../Colors");
const GlobalStateProvider_1 = require("../../../../GlobalStateProvider");
const common_1 = require("../../../../common");
const server_1 = require("../../../../server");
const funtions_1 = require("../../../DST/DSTT001/funtions");
const account_1 = require("../../account");
const popup_1 = require("../../popup");
const loading_final_json_1 = __importDefault(require("./../../../../assest/loading-final.json"));
const LottieAnimation_1 = __importDefault(require("./LottieAnimation"));
const LiveEnquiriesStyled = styled_components_1.default.div `
	display: flex;
	flex-direction: column;
	gap: 20px;
	.title {
		color: var(--color-black, #101010);
		text-align: left;
		font-family: var(--h4-font-family, 'Noto Sans KR', sans-serif);
		font-size: var(--h4-font-size, 20px);
		line-height: var(--h4-line-height, 32px);
		letter-spacing: var(--h4-letter-spacing, -0.02em);
		font-weight: var(--h4-font-weight, 700);
		position: relative;
		align-self: stretch;
		display: flex;
		align-items: center;
		justify-content: flex-start;
	}

	.popup-list-009 {
		display: flex;
		flex-direction: column;
		gap: 0px;
		align-items: flex-start;
		justify-content: flex-start;
		flex-shrink: 0;
		height: unset;
		position: relative;

		.table-header {
			background: var(--color-silver, #f3f4f8);
			border-style: solid;
			border-color: var(--color-grey-w, #b6bac0);
			border-width: 1px 0px 0px 0px;
			padding: 10px 16px 10px 16px;
			display: flex;
			flex-direction: row;
			gap: 20px;
			align-items: center;
			justify-content: flex-start;
			flex-shrink: 0;
			position: relative;

			p {
				color: var(--color-black, #101010);
				text-align: left;
				font-family: var(--b4-font-family, 'Noto Sans KR', sans-serif);
				font-size: var(--b4-font-size, 14px);
				line-height: var(--b4-line-height, 28px);
				letter-spacing: var(--b4-letter-spacing, -0.02em);
				font-weight: var(--b4-font-weight, 400);
				position: relative;
			}
		}

		.item {
			.body-item {
				overflow: hidden;
			}
		}
	}

	&.waiting {
		.container,
		.container * {
			box-sizing: border-box;
		}
		.container {
			padding: 20px 0px 20px 0px;
			display: flex;
			flex-direction: column;
			gap: 18px;
			align-items: center;
			justify-content: center;
			flex-shrink: 0;
			position: relative;
			overflow: hidden;
		}
		.txt {
			color: var(--color-black, #101010);
			text-align: center;
			font-family: var(--h3-font-family, 'Noto Sans KR', sans-serif);
			font-size: var(--h3-font-size, 24px);
			line-height: var(--h3-line-height, 36px);
			letter-spacing: var(--h3-letter-spacing, -0.02em);
			font-weight: var(--h3-font-weight, 700);
			position: relative;
			display: flex;
			align-items: center;
			justify-content: center;
		}
		.loading-final-1-1 {
			flex-shrink: 0;
			width: 150px;
			height: 150px;
			position: relative;
			object-fit: cover;
		}
		.txt2 {
			text-align: center;
			font-family: var(--b2-font-family, 'Noto Sans KR', sans-serif);
			font-size: var(--b2-font-size, 18px);
			line-height: var(--b2-line-height, 36px);
			letter-spacing: var(--b2-letter-spacing, -0.02em);
			font-weight: var(--b2-font-weight, 400);
			position: relative;
			display: flex;
			align-items: center;
			justify-content: center;
		}
		.txt-2-span {
			color: var(--color-black, #101010);
			font-family: var(--b2-font-family, 'Noto Sans KR', sans-serif);
			font-size: var(--b2-font-size, 18px);
			line-height: var(--b2-line-height, 36px);
			letter-spacing: var(--b2-letter-spacing, -0.02em);
			font-weight: var(--b2-font-weight, 400);
		}
		.txt-2-span2 {
			color: var(--color-pink, #f46790);
			font-family: var(--b2-font-family, 'Noto Sans KR', sans-serif);
			font-size: var(--b2-font-size, 18px);
			line-height: var(--b2-line-height, 36px);
			letter-spacing: var(--b2-letter-spacing, -0.02em);
			font-weight: var(--b2-font-weight, 400);
		}
		.txt-2-span3 {
			color: var(--color-black, #101010);
			font-family: var(--b2-font-family, 'Noto Sans KR', sans-serif);
			font-size: var(--b2-font-size, 18px);
			line-height: var(--b2-line-height, 36px);
			letter-spacing: var(--b2-letter-spacing, -0.02em);
			font-weight: var(--b2-font-weight, 400);
		}
	}

	.empty_data {
		display: flex;
		flex-direction: column;
		gap: 0px;
		align-items: center;
		justify-content: space-around;
		width: 100%;
		height: 100%;

		.guid {
			color: var(--color-grey, #666666);
			text-align: left;
			font-family: 'Noto Sans KR', sans-serif;
			font-size: 18px;
			line-height: 150%;
			letter-spacing: -0.02em;
			font-weight: 400;
			position: relative;
			display: flex;
			align-items: center;
			justify-content: flex-start;
		}
	}

	${props => (props.$isMobile ? mobileStyles : desktopStyles)}
`;
const mobileStyles = (0, styled_components_1.css) `
	.popup-list-009 {
		.item {
			border-style: solid;
			border-color: var(--color-silver, #f3f4f8);
			border-width: 0px 0px 1px 0px;
			padding: 10px 0px 10px 0px;
			display: flex;
			flex-direction: column;
			align-items: flex-start;
			justify-content: flex-start;
			flex-shrink: 0;
			position: relative;

			color: var(--color-black, #101010);
			text-align: left;
			font-family: var(--b4-font-family, 'Noto Sans KR', sans-serif);
			font-size: var(--b4-font-size, 12px);
			line-height: 150%;
			letter-spacing: var(--b4-letter-spacing, -0.02em);
			font-weight: var(--b4-font-weight, 400);
			position: relative;

			&.underline {
				cursor: pointer;
				text-decoration: underline;
			}
		}

		.bold {
			font-size: 14px;
			line-height: 150%;
			letter-spacing: -0.02em;
			font-weight: 700;
		}

		.live-mobile-wrap {
			display: flex;
			width: 100%;

			.live-contents-wrap {
				width: 100%;
			}

			.live-status {
				min-width: 45px;
				display: flex;
				justify-content: center;
				align-items: center;
			}

			.underline {
				cursor: pointer;
				text-decoration: underline;
				font-size: var(--b4-font-size, 14px);
				color: var(--bule, #3c5295);
			}
		}
	}
`;
const desktopStyles = (0, styled_components_1.css) `
	.popup-list-009 {
		.item {
			padding: 8px 16px 8px 16px;
			display: flex;
			flex-direction: row;
			gap: 20px;
			align-items: center;
			justify-content: flex-start;
			flex-shrink: 0;
			position: relative;

			span {
				color: var(--color-black, #101010);
				text-align: left;
				font-family: var(--b4-font-family, 'Noto Sans KR', sans-serif);
				font-size: var(--b4-font-size, 14px);
				line-height: var(--b4-line-height, 28px);
				letter-spacing: var(--b4-letter-spacing, -0.02em);
				font-weight: var(--b4-font-weight, 400);
				position: relative;

				&.underline {
					cursor: pointer;
					text-decoration: underline;
				}
			}
		}
	}
`;
exports.LiveEnquiries = react_1.default.memo(({ liveRoom }) => {
    const { isMobile } = (0, GlobalStateProvider_1.useGlobalState)();
    const isTeacher = (0, react_redux_1.useSelector)((state) => (0, account_1.getIsTeacher)(state));
    const manager_local_id = (0, react_redux_1.useSelector)((state) => (0, account_1.getIsManagerAndUserId)(state));
    const localId = (0, react_redux_1.useSelector)((state) => (0, account_1.getUserId)(state));
    const [testData, setTestData] = (0, react_1.useState)([]);
    const [totalCount, setTotalCount] = (0, react_1.useState)(0);
    const [page, setPage] = (0, react_1.useState)(0);
    const [waitingRoomId, setWaitingRoomId] = (0, react_1.useState)('');
    const [entering, setEntering] = (0, react_1.useState)(false);
    const registEnquiryMutation = (0, react_query_1.useMutation)(server_1.postEnquiriesList);
    const rejectedEnquiryMutation = (0, react_query_1.useMutation)(server_1.postoutEnquiriesList);
    const { data, refetch } = (0, server_1.useEnquiriesList)({
        conference_id: liveRoom.map(i => i.id),
        ...(manager_local_id ? { host: manager_local_id } : {}),
        status: 'held',
        with_more_info: true,
    });
    const refetchList = (0, throttle_1.default)(() => {
        refetch();
    }, 1000, { trailing: false, leading: true });
    (0, react_1.useEffect)(() => {
        if (liveRoom && liveRoom.length > 0) {
            refetchList();
            return;
        }
        setTestData([]);
        setTotalCount(0);
    }, [liveRoom]);
    const { headTitleList, tableReadDataKeys } = (0, react_1.useMemo)(() => {
        const headTitleList = [
            { title: 'seperate', space: 1, sort: false },
            { title: 'contentTitle', space: 3, sort: false },
            { title: 'charge', space: 1, sort: false },
            { title: 'waiting', space: 1, sort: false },
            { title: 'etc', space: 1, sort: false },
        ];
        const tableReadDataKeys = [
            { title: 'type', space: 1, sort: false },
            { title: 'title', space: 3, sort: false },
            { title: 'host_name', space: 1, sort: false },
            { title: 'waiting', space: 1, sort: false },
            { title: 'etc', space: 1, sort: false },
        ];
        return { headTitleList, tableReadDataKeys };
    }, []);
    (0, react_1.useEffect)(() => {
        APP.eventManager.subscribe('RERENDER_LIVE_ENQUIRIES', refetchList);
        return () => {
            APP.eventManager.unsubscribe('RERENDER_LIVE_ENQUIRIES', refetchList);
        };
    }, []);
    (0, react_1.useEffect)(() => {
        if (data) {
            const { total_count, items } = data;
            if (total_count > 0) {
                setTestData(items);
                setTotalCount(total_count);
                const waitingRoom = items.find(i => i.id === waitingRoomId);
                const isEnterMember = items.find(i => i?.members_id.includes(localId));
                if (!waitingRoom) {
                    if (isEnterMember)
                        return;
                    setWaitingRoomId(undefined);
                }
                if (items && items.length > 0) {
                    const waiting = items.find(i => i.id === waitingRoomId);
                    if (waiting && !waiting?.host_occupied) {
                        queueOutList(waitingRoomId, !entering);
                        setWaitingRoomId(undefined);
                    }
                }
                return;
            }
        }
        setTestData([]);
        setTotalCount(0);
    }, [data]);
    const queueOutList = async (waitingRoomId, entering) => {
        if (entering)
            return;
        if (waitingRoomId) {
            try {
                await rejectedEnquiryMutation.mutateAsync(waitingRoomId);
            }
            catch (error) {
                alert(error);
            }
            finally {
                setWaitingRoomId(undefined);
            }
        }
    };
    const closePopup = () => {
        APP.eventManager.publish(popup_1.TOGGLE_POPUP);
    };
    // 학생만 동작
    (0, react_1.useEffect)(() => {
        // 학생인 경우 -> 대기열 수락
        const acceptedUser = async (data) => {
            const { class_id, enquiry_id } = data;
            if (enquiry_id === waitingRoomId) {
                await (0, funtions_1.goToConference)(enquiry_id, 'live');
                setTimeout(() => {
                    setEntering(true);
                    closePopup();
                }, 2000);
            }
        };
        !isTeacher && APP.eventManager.subscribe('QUEUE_ACCEPTED', acceptedUser);
        return () => {
            !isTeacher && APP.eventManager.unsubscribe('QUEUE_ACCEPTED', acceptedUser);
        };
    }, [isTeacher, waitingRoomId]);
    // 대기가 해제되었을때 대기열에서 제외
    (0, react_1.useEffect)(() => {
        setEntering(false);
        return () => {
            if (!entering)
                queueOutList(waitingRoomId, !entering);
        };
    }, [waitingRoomId, entering]);
    (0, react_1.useEffect)(() => {
        const handleBeforeUnload = event => {
            queueOutList(waitingRoomId, false);
            // 필요하다면 사용자에게 경고 메시지를 표시할 수 있습니다
            event.preventDefault();
            event.returnValue = '';
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [waitingRoomId, entering]);
    const registRoom = async (id) => {
        try {
            await registEnquiryMutation.mutateAsync({ id });
            setWaitingRoomId(id);
        }
        catch (error) {
            alert(error);
        }
        finally {
            refetchList();
        }
    };
    const disableRoom = async (id) => {
        try {
            await rejectedEnquiryMutation.mutateAsync(id);
            setWaitingRoomId(undefined);
        }
        catch (error) {
            alert(error);
        }
        finally {
            refetchList();
        }
    };
    const isOnline = (0, react_1.useMemo)(() => testData.find(item => isTeacher
        ? item.host_occupied
        : // @ts-ignore
            item.members &&
                item.members.find(i => i.member_id === localId && i.status === 'occupied'))
        ? true
        : false, [testData, isTeacher, localId]);
    // const renderTitle = useMemo(() => {
    // 	const title = isTeacher ? null : liveRoom[0]?.title;
    // 	return isTeacher ? null : <div className="title">[{title}]</div>;
    // }, [isTeacher]);
    const renderEmpty = (0, react_1.useMemo)(() => {
        if (testData.length === 0) {
            return (react_1.default.createElement("div", { className: "empty_data" },
                react_1.default.createElement(common_1.Button, { className: "text guid", text: "\uC9C4\uD589\uC911\uC778 1:1 Live \uBB38\uC758 \uBC29\uC774 \uC5C6\uC2B5\uB2C8\uB2E4" }),
                react_1.default.createElement(common_1.Button, { className: `btn_default ${isMobile ? 'sm' : 'xmd'}`, text: "common.okay", onClick: closePopup })));
        }
    }, [testData]);
    const renderContent = (item, headItem, index, styles) => {
        const live_data = liveRoom.find(i => i.id === item.parent_id);
        return (headItem.title === 'host_name' || headItem.title === 'etc') && isMobile ? null : (react_1.default.createElement("div", { key: index, className: "body-item", style: {
                flex: !isMobile && headItem.space,
                ...styles?.bodyItem,
            } }, headItem.title === 'etc' ? (!isTeacher && !item.host_occupied ? null : item.waiting &&
            item.waiting.length > 0 &&
            item.waiting.find(i => i.id === localId) ? (react_1.default.createElement("span", { className: "underline", onClick: isTeacher ? null : () => disableRoom(item.id) }, "\uB300\uAE30 \uD574\uC81C")) : (react_1.default.createElement("span", { className: "underline", onClick: isTeacher
                ? item.host_occupied
                    ? null
                    : () => (0, funtions_1.goToConference)(item.id, 'live')
                : isOnline
                    ? null
                    : () => registRoom(item.id) }, isTeacher
            ? item.host_occupied
                ? '입장중'
                : '입장'
            : isOnline
                ? '입장중'
                : '대기'))) : headItem.title === 'waiting' ? (isMobile ? (react_1.default.createElement("div", { style: { gap: '4px', display: 'flex' } },
            react_1.default.createElement("span", { className: "overText2", style: { color: Colors_1.Colors.light_grey } }, item['host_name']),
            react_1.default.createElement("span", { className: "overText" },
                item.waiting?.length,
                "\uBA85"))) : (react_1.default.createElement("span", { className: "overText2" },
            item.waiting?.length,
            " \uBA85"))) : headItem.title === 'type' ? (react_1.default.createElement("span", { className: "overText2" }, item.host_occupied ? '대기중' : '미대기중')) : headItem.title === 'title' ? (react_1.default.createElement("span", { className: "overText2 bold" },
            `${live_data?.title} - `,
            " ",
            item[headItem.title])) : (react_1.default.createElement("span", { className: "overText2" }, item[headItem.title]))));
    };
    const renderItem = (item, styles) => {
        return (react_1.default.createElement(react_1.default.Fragment, null, isMobile ? (react_1.default.createElement("div", { className: "live-mobile-wrap" },
            react_1.default.createElement("div", { className: "live-contents-wrap" }, tableReadDataKeys.map((headItem, index) => renderContent(item, headItem, index))),
            react_1.default.createElement("div", { className: "live-status" }, !isTeacher && !item.host_occupied ? null : item.waiting &&
                item.waiting.length > 0 &&
                item.waiting.find(i => i.id === localId) ? (react_1.default.createElement("span", { className: "underline", onClick: isTeacher ? null : () => disableRoom(item.id) }, "\uB300\uAE30 \uD574\uC81C")) : (react_1.default.createElement("span", { className: "underline", onClick: isOnline
                    ? null
                    : isTeacher
                        ? () => (0, funtions_1.goToConference)(item.id, 'live')
                        : () => registRoom(item.id) }, isOnline ? '입장중' : isTeacher ? '입장' : '대기'))))) : (tableReadDataKeys.map((headItem, index) => renderContent(item, headItem, index)))));
    };
    if (waitingRoomId) {
        const items = testData.find(i => i.id === waitingRoomId);
        if (!items)
            return null;
        return (react_1.default.createElement(LiveEnquiriesStyled, { "$isMobile": isMobile, className: "waiting" },
            react_1.default.createElement("div", { className: "container" },
                react_1.default.createElement("div", { className: "txt" }, "\uC7A0\uC2DC\uB9CC \uAE30\uB2E4\uB824 \uC8FC\uC2ED\uC2DC\uC624"),
                react_1.default.createElement(LottieAnimation_1.default, { animationData: loading_final_json_1.default, width: 150, height: 150 }),
                react_1.default.createElement("div", { className: "txt2" },
                    react_1.default.createElement("span", null,
                        react_1.default.createElement("span", { className: "txt-2-span" }, "\uD604\uC7AC \uB300\uAE30\uC778\uC6D0"),
                        react_1.default.createElement("span", { className: "txt-2-span2" },
                            ' ',
                            items.waiting.length,
                            "\uBA85\uC73C\uB85C \uB300\uAE30\uC2DC\uAC04 \uCD5C\uC18C",
                            ' ',
                            items.waiting.length * 10,
                            "\uBD84 \uC774\uC0C1"),
                        react_1.default.createElement("span", { className: "txt-2-span3" },
                            "\uC18C\uC694\uB429\uB2C8\uB2E4",
                            react_1.default.createElement("br", null),
                            "\uCDE8\uC18C \uC2DC \uB300\uAE30\uC778\uC6D0\uC5D0\uC11C \uC81C\uC678\uB418\uBA70, \uB2E4\uC2DC \uB300\uAE30\uB97C \uD574\uC57C \uD569\uB2C8\uB2E4"))),
                react_1.default.createElement(common_1.Button, { className: "btn_default xmd", text: "\uB300\uAE30 \uCDE8\uC18C", onClick: () => disableRoom(waitingRoomId) }))));
    }
    return (react_1.default.createElement(LiveEnquiriesStyled, { "$isMobile": isMobile },
        react_1.default.createElement(common_1.Table, { className: "popup-list-009", isInfinite: true, page: page, data: testData, totalCount: totalCount, headTitleList: headTitleList, 
            // renderTitle={renderTitle}
            renderEmpty: renderEmpty, renderItem: renderItem, forceShowheader: testData.length === 0 || isMobile ? false : true })));
});
